import React, { useState } from 'react';
import { StyledButton, StyledCarousel, StyledContainer, StyledFlex, StyledModal } from './OneRegistryCard.styles';
import { registryPageData } from '@data-ts/pages/registry';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';
import { FeatureCard } from '@sections/registry/ShopSection/components/FeatureCard';
import { Card } from '@sections/registry/components';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { themeColor } from '@utils/styledTheme.util';
import { useTheme } from 'styled-components';
const {
  shopSection: { oneRegistryCard },
} = registryPageData;

const SLIDE_WIDTH = '800px';

export const OneRegistryCard = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isBelowSm = useThemeMediaQuery('below_sm');
  const [currentCardIndex, setCurrentCardIndex] = useState(0);

  const theme = useTheme();
  return (
    <>
      <LazyLoadWrapper beforeLoad={() => setIsVisible(true)}>
        <></>
      </LazyLoadWrapper>
      <Card
        eyebrow={oneRegistryCard.eyebrow}
        eyebrowVariant="featureHed17"
        eyebrowColor="blue4"
        title={oneRegistryCard.title}
        titleVariant="calloutHed32"
        titleColor="white"
        wrapperStyles={{
          backgroundImage: `url(${
            isVisible ? cloudAssetUrl('registry-q12024/gifts-you-want/bkg-addanything@2x.png', { optimization: 'default' }) : ''
          })`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          cursor: 'pointer',
          backgroundColor: themeColor('accentBlue6')({ theme }),
        }}
        handleClick={() => {
          setIsModalOpen(true);
          setCurrentCardIndex(0);
        }}
      >
        <StyledButton
          id="learnMoreAboutRegistry"
          variant="primeWeddingWebsites"
          onClick={() => {
            setIsModalOpen(true);
            setCurrentCardIndex(0);
          }}
        >
          {oneRegistryCard.learnMoreCTA}
        </StyledButton>
      </Card>
      <StyledModal
        isOpen={isModalOpen}
        style={{
          overlay: {
            background: 'rgba(0, 0, 0, 0.48)',
            backdropFilter: 'blur(6px)',
            zIndex: 101,
            overflow: 'hidden',
            overflowY: 'auto',
            display: 'flex',
            alignItems: 'center',
          },
          content: {
            display: 'flex',
            width: '100%',
          },
        }}
      >
        <StyledContainer>
          <StyledCarousel
            frameOverflow="visible"
            transitionMode="scroll3d"
            defaultControlsConfig={{
              nextButtonStyle: {
                display: 'none',
              },
              prevButtonStyle: {
                display: 'none',
              },
              pagingDotsClassName: 'one-registry-paging-dot',
            }}
            speed={1000}
            slideWidth={isBelowSm ? undefined : SLIDE_WIDTH}
            cellSpacing={32}
            slideIndex={currentCardIndex}
          >
            {oneRegistryCard.modalContent.map((content, idx) => (
              <StyledFlex key={idx} onClick={() => setCurrentCardIndex(idx)}>
                <FeatureCard
                  eyebrow={content.eyebrow}
                  imageUrl={content.src}
                  title={content.title}
                  onClose={() => setIsModalOpen(false)}
                  step={idx + 1}
                  id={`one-registry-${idx}`}
                />
              </StyledFlex>
            ))}
          </StyledCarousel>
        </StyledContainer>
      </StyledModal>
    </>
  );
};
